import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';
import { QuestionnaireCsrdQuestionInstancesDto } from 'app/@types/dto/questionnaire-csrd-question-instance-dto.model';
import { QuestionCsrdInstanceDto } from 'app/@types/dto/question-csrd-instance-dto.model';
import { QuestionnaireCsrdDto } from 'app/@types/dto/questionnaire-csrd-dto.model';
import { ResultCsrdDto } from 'app/@types/dto/result-csrd-dto.model';

@Injectable({
    providedIn: 'root',
})
export class QuestionnaireCsrdHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getQuestionnaireCsrd(orgId: string, year: number): Observable<QuestionnaireCsrdQuestionInstancesDto> {
        return this.http.get<QuestionnaireCsrdQuestionInstancesDto>(this.urlService.getQuestionnaireCsrd(orgId, year));
    }

    createQuestionnaireCsrd(orgId: string, year: number): Observable<QuestionnaireCsrdDto> {
        return this.http.post<QuestionnaireCsrdDto>(this.urlService.createQuestionnaireCsrd(orgId), {
            organizationId: orgId,
            refYear: year,
        } as QuestionnaireCsrdDto);
    }

    getAll(organizationId: string) {
        return this.http.get<QuestionnaireCsrdDto[]>(this.urlService.getAllQuestionnairesCsrd(organizationId));
    }

    createUpdateQuestionInstance(orgId: string, questionInstance: QuestionCsrdInstanceDto) {
        return this.http.put<QuestionCsrdInstanceDto>(
            this.urlService.createUpdateQuestionCsrdInstance(orgId),
            questionInstance,
        );
    }

    deleteQuestionInstance(orgId: string, questionInstance: QuestionCsrdInstanceDto) {
        return this.http.delete<void>(this.urlService.deleteQuestionCsrdInstance(orgId), { body: questionInstance });
    }

    updateQuestionnaire(questionnaire: QuestionnaireCsrdDto) {
        return this.http.put<QuestionnaireCsrdDto>(
            this.urlService.updateQuestionnaireCsrd(questionnaire.organizationId),
            questionnaire,
        );
    }

    editQuestionnairePeriod(organizationId: string, currentYear: number, newYear: number): Observable<void> {
        return this.http.put<void>(this.urlService.editQuestionnairesCsrdPeriod(organizationId), {
            currentYear,
            newYear,
        });
    }

    deleteQuestionnaireFromPeriod(organizationId: string, year: number): Observable<void> {
        return this.http.delete<void>(this.urlService.deleteQuestionnaireCsrdFromPeriod(organizationId, year));
    }

    getResults(orgId: string, questionnaireId: string) {
        return this.http.get<ResultCsrdDto[]>(this.urlService.getResultsCsrd(orgId, questionnaireId));
    }
}
